/* "Framed Sizes" tab on the standard product pages: a plain size chart for framed fine art prints (Craig 2026-10-23: "just the size guide, so they
   can just see dimensions"). Heading + one table of every size on this product: print, framed, framed with window mount.
   Measurements are the ones the old Framed Art Size Guide used: 22 mm frame face on every side; window mount border 30 mm (A4, A3, 30 x 30 cm)
   or 40 mm (every larger size); overall = print + 2 x mount (if any) + 2 x frame.
   Presentation only: it reads the product's own Size / Type / Frame Options radios and never changes a choice.
   Must load BEFORE sg-tabs-row.js: it fills (or removes) its tab before the tab row is built. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var FRAME = 2.2;                                   // cm, frame face per side
  var r1 = function (v) { return (Math.round(v * 10) / 10).toString(); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var FRAMES = ['black', 'white', 'light oak look', 'dark kiaat look'];

  function findBlock() {
    return $$('.product-block--tab').filter(function (b) { return /\[framed-sizes\]/.test(b.textContent); })[0] || null;
  }
  function sizes() {
    return $$('.variant-wrapper input[name="Size"]').map(function (r) {
      var m = /(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i.exec(r.value); if (!m) return null;
      var w = +m[1], h = +m[2], a = /^\s*([A-Z]\d)\s*-/.exec(r.value);
      return { w: w, h: h, name: a ? a[1] : r1(w) + ' × ' + r1(h) + ' cm', mount: Math.min(w, h) <= 30 ? 3 : 4 };
    }).filter(Boolean);
  }
  function radioVals(name) { return $$('.variant-wrapper input[name="' + name + '"]').map(function (r) { return r.value; }); }

  function init() {
    var block = findBlock(); if (!block) return;
    var S = sizes();
    var frames = radioVals('Frame Options').filter(function (v) { return FRAMES.indexOf(v.toLowerCase()) > -1; });
    if (radioVals('Type').indexOf('Fine Art Print') < 0 || !frames.length || !S.length) { block.parentNode.removeChild(block); return; }   // nothing framed to measure

    // Overseas (UK/EU/US): framed by Printumo, not by our SA framer, so the 22 mm frame maths does not apply and
    // Printumo publishes no frame width ("The measurements refer to the size of prints it fits. The actual frame size is
    // slightly bigger depending on your selected frame profile and size." — printumo.com pricing page, read 2026-10-27).
    // Show the print size each market actually gets (US: the inch label from snippets/sg-us-size-labels.liquid) and say so.
    // Region from product-template.liquid's data-sg-region (sg-overseas-region: GB / EU / US, absent for South Africa), so this
    // follows exactly what the page's Liquid did, including the theme's overseas on/off switch, rather than Shopify.country.
    var regEl = $('[data-sg-region]'), region = regEl ? regEl.getAttribute('data-sg-region') : '';
    if (region) {
      var us = region === 'US';
      var rows = $$('.variant-wrapper input[name="Size"]').map(function (r) {
        var l = r.id ? $('label[for="' + r.id + '"]') : null;
        var lab = l ? (l.getAttribute('data-sg-orig') || l.textContent).trim().replace(/\s+/g, ' ') : '';
        var m = /(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i.exec(r.value); if (!m) return null;
        var a = /^\s*([A-Z]\d)\s*-/.exec(r.value);
        var name = a ? a[1] : r1(+m[1]) + ' × ' + r1(+m[2]) + ' cm';
        var print = us && /\bin\b/.test(lab) ? lab.replace(/\s*[x×]\s*/i, ' × ') : r1(+m[1]) + ' × ' + r1(+m[2]) + ' cm';
        return us ? '<tr><td>' + esc(print) + '</td></tr>' : '<tr><td>' + esc(name) + '</td><td>' + esc(print) + '</td></tr>';
      }).filter(Boolean);
      var o = '<p class="sg-fs__heading"><strong>Framed Fine Art Prints</strong></p>';
      o += '<table class="sg-fs__table"><thead><tr>' + (us ? '<th>Print size</th>' : '<th>Size</th><th>Print</th>') + '</tr></thead><tbody>' + rows.join('') + '</tbody></table>';
      o += '<p class="sg-fs__note">Print sizes, width × height. The frame adds a little on every side, depending on the frame profile.</p>';
      var inn = $('.collapsible-content__inner', block) || block;
      inn.innerHTML = '<div class="sg-fs" id="sg-fs">' + o + '</div>';
      return;
    }

    var mountSold = !!$('#window-mount-checkbox');
    var dims = function (s, mount) { var m = mount ? s.mount : 0; return { w: s.w + 2 * (m + FRAME), h: s.h + 2 * (m + FRAME) }; };
    var h = '<p class="sg-fs__heading"><strong>Framed Fine Art Prints</strong></p>';
    h += '<table class="sg-fs__table"><thead><tr><th>Size</th><th>Print</th><th>Framed</th>' + (mountSold ? '<th>Framed with mount</th>' : '') + '</tr></thead><tbody>';
    S.forEach(function (x) {
      var a = dims(x, false), b = dims(x, true);
      h += '<tr><td>' + esc(x.name) + '</td><td>' + r1(x.w) + ' × ' + r1(x.h) + '</td><td>' + r1(a.w) + ' × ' + r1(a.h) + '</td>' + (mountSold ? '<td>' + r1(b.w) + ' × ' + r1(b.h) + '</td>' : '') + '</tr>';
    });
    h += '</tbody></table><p class="sg-fs__note">All sizes in centimetres, width × height. Framed sizes include the 22 mm frame' +
      (mountSold ? ' and, where shown, the white window mount (30 mm border on A4, A3 and 30 × 30 cm, 40 mm on larger sizes).' : '.') + '</p>';
    var inner = $('.collapsible-content__inner', block) || block;
    inner.innerHTML = '<div class="sg-fs" id="sg-fs">' + h + '</div>';
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
